import * as angular from 'angular';

import {
    ContextualField, PropertyType, GuidObjectType,
} from '../../../../models/index';

import {
    ShortComment,
    LongComment,
    CustomProperties
} from '../../../../common/helpers/contextual';

export function getCommonProperties() {
    // Object.assign seems to be problematic for PhantomJS - maybe polyfill is not called yet?
    const customProperties: ContextualField = angular.copy(CustomProperties);
    customProperties.extraData.type = GuidObjectType.Identifier;
    const commonProperties: ContextualField[] = [
        {
            modelName: 'name',
            propertyType: PropertyType.Text,
            label: 'Name',
            placeholder: 'Name',
            propertyName: 'nameProperty',
            required: true,
            icon: 'fa-id-badge',
            isValid: value => {
                return {};
            },
            messages: [
                { key: 'required', value: 'A name is required' },
                { key: 'duplicate', value: 'This name is already in use' }
            ]
        },
        angular.copy(ShortComment), 
        angular.copy(LongComment),
        customProperties
    ];
    return commonProperties;
}
